import { createStateSelectorHook } from 'src/lib/sweetState';

import { PopupStore } from '../../store';

const usePopupState = createStateSelectorHook(PopupStore, [
  'selectedModelId',
  'customModels',
  'isLoading',
]);

export const useViewState = (assetType) => {
  const { selectedModelId, customModels, isLoading } = usePopupState();

  const filteredCustomModels = customModels.filter((model) => model.assetTypes.includes(assetType));

  return {
    selectedModelId,
    customModels: assetType ? filteredCustomModels : customModels,
    isLoading,
  };
};
